(function () {
  var HOURS = {
    3: { open: '06:00', close: '16:00' },
    4: { open: '06:00', close: '16:00' },
    5: { open: '06:00', close: '16:00' },
    6: { open: '06:00', close: '14:00' }
  };

  var SLOT_MINUTES = 15;
  var DOW = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  var MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  var FULL_MONTHS = [
    'January', 'February', 'March', 'April', 'May', 'June',
    'July', 'August', 'September', 'October', 'November', 'December'
  ];

  function pad(n) {
    return String(n).padStart(2, '0');
  }

  function toIsoDate(d) {
    return d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate());
  }

  function parseIsoDate(str) {
    if (!str) return null;
    var parts = str.split('-');
    if (parts.length !== 3) return null;
    return new Date(Number(parts[0]), Number(parts[1]) - 1, Number(parts[2]));
  }

  function stripTime(d) {
    return new Date(d.getFullYear(), d.getMonth(), d.getDate());
  }

  function isOpenDay(date) {
    return !!HOURS[date.getDay()];
  }

  function nextOpenDay(from) {
    var d = stripTime(from);
    for (var i = 0; i < 14; i++) {
      if (isOpenDay(d)) return d;
      d.setDate(d.getDate() + 1);
    }
    return d;
  }

  function getMinDate() {
    var tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate() + 1);
    return nextOpenDay(tomorrow);
  }

  function getMaxDate() {
    var d = new Date();
    d.setMonth(d.getMonth() + 2);
    return stripTime(d);
  }

  function isDateSelectable(d) {
    var date = stripTime(d);
    return isOpenDay(date) && date >= getMinDate() && date <= getMaxDate();
  }

  function parseTime24(str) {
    var parts = str.split(':');
    return Number(parts[0]) * 60 + Number(parts[1]);
  }

  function formatTime24(totalMinutes) {
    var h = Math.floor(totalMinutes / 60);
    var m = totalMinutes % 60;
    return pad(h) + ':' + pad(m);
  }

  function formatTime12(time24) {
    var parts = time24.split(':');
    var h = parseInt(parts[0], 10);
    var m = parts[1];
    var ampm = h >= 12 ? 'PM' : 'AM';
    var h12 = h % 12 || 12;
    return h12 + ':' + m + ' ' + ampm;
  }

  function getTimeSlots(dayOfWeek) {
    var h = HOURS[dayOfWeek];
    if (!h) return [];
    var slots = [];
    var start = parseTime24(h.open);
    var end = parseTime24(h.close);
    for (var m = start; m <= end; m += SLOT_MINUTES) {
      slots.push(formatTime24(m));
    }
    return slots;
  }

  function formatSelection(dateIso, time24) {
    var d = parseIsoDate(dateIso);
    if (!d || !time24) return '';
    return DOW[d.getDay()] + ', ' + MONTHS[d.getMonth()] + ' ' + d.getDate() + ' at ' + formatTime12(time24);
  }

  function saveAttributes(dateVal, timeVal) {
    var payload = {
      attributes: {
        'Pickup Date': dateVal || '',
        'Pickup Time': timeVal || ''
      }
    };

    if (window.Shopify && Shopify.theme && Shopify.theme.cart && Shopify.theme.cart.updateAttributes) {
      return Shopify.theme.cart.updateAttributes(payload.attributes);
    }

    return fetch(window.Shopify.routes.root + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify(payload)
    }).then(function (r) {
      if (!r.ok) throw new Error('Could not save pickup details');
      return r.json();
    });
  }

  function bindScheduler(root) {
    if (root.dataset.lbPickupBound === 'true') return;
    root.dataset.lbPickupBound = 'true';

    var dateEl = root.querySelector('.js-lb-pickup-date');
    var timeEl = root.querySelector('.js-lb-pickup-time');
    var datesEl = root.querySelector('.js-lb-pickup-dates');
    var timesEl = root.querySelector('.js-lb-pickup-times');
    var titleEl = root.querySelector('.js-lb-cal-title');
    var prevBtn = root.querySelector('.js-lb-cal-prev');
    var nextBtn = root.querySelector('.js-lb-cal-next');
    var timeSection = root.querySelector('[data-lb-time-section]');
    var selectionEl = root.querySelector('.js-lb-pickup-selection');
    var errorEl = root.querySelector('.js-lb-pickup-error');
    var statusEl = root.querySelector('.js-lb-pickup-status');
    if (!dateEl || !timeEl || !datesEl || !timesEl || !titleEl || !prevBtn || !nextBtn) return;

    var viewYear;
    var viewMonth;
    var selectedDateBtn = null;
    var selectedTimeBtn = null;

    function showError(msg) {
      if (!errorEl) return;
      if (msg) {
        errorEl.hidden = false;
        errorEl.textContent = msg;
      } else {
        errorEl.hidden = true;
        errorEl.textContent = '';
      }
    }

    function showStatus(msg) {
      if (statusEl) statusEl.textContent = msg || '';
    }

    function updateSelectionSummary() {
      if (!selectionEl) return;
      var text = formatSelection(dateEl.value, timeEl.value);
      selectionEl.textContent = text ? 'Pickup: ' + text : '';
    }

    function clearTimeSelection() {
      timeEl.value = '';
      if (selectedTimeBtn) {
        selectedTimeBtn.classList.remove('is-selected');
        selectedTimeBtn.setAttribute('aria-selected', 'false');
        selectedTimeBtn = null;
      }
    }

    function renderTimeSlots(dayOfWeek) {
      timesEl.innerHTML = '';
      clearTimeSelection();
      getTimeSlots(dayOfWeek).forEach(function (slot) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'lb-pickup-scheduler__time-btn';
        btn.setAttribute('role', 'option');
        btn.setAttribute('aria-selected', 'false');
        btn.dataset.value = slot;
        btn.textContent = formatTime12(slot);
        btn.addEventListener('click', function () {
          if (selectedTimeBtn) {
            selectedTimeBtn.classList.remove('is-selected');
            selectedTimeBtn.setAttribute('aria-selected', 'false');
          }
          selectedTimeBtn = btn;
          btn.classList.add('is-selected');
          btn.setAttribute('aria-selected', 'true');
          timeEl.value = slot;
          showError('');
          updateSelectionSummary();
          persist();
        });
        timesEl.appendChild(btn);
      });
    }

    function canGoPrev() {
      var min = getMinDate();
      return viewYear > min.getFullYear() || (viewYear === min.getFullYear() && viewMonth > min.getMonth());
    }

    function canGoNext() {
      var max = getMaxDate();
      return viewYear < max.getFullYear() || (viewYear === max.getFullYear() && viewMonth < max.getMonth());
    }

    function setViewMonth(year, month) {
      viewYear = year;
      viewMonth = month;
      renderCalendar();
    }

    function selectDate(iso, btn) {
      if (selectedDateBtn) selectedDateBtn.classList.remove('is-selected');
      selectedDateBtn = btn;
      if (btn) btn.classList.add('is-selected');
      dateEl.value = iso;
      var picked = parseIsoDate(iso);
      if (timeSection) timeSection.classList.remove('is-disabled');
      renderTimeSlots(picked.getDay());
      showError('');
      updateSelectionSummary();
    }

    function renderCalendar() {
      titleEl.textContent = FULL_MONTHS[viewMonth] + ' ' + viewYear;
      datesEl.innerHTML = '';
      prevBtn.disabled = !canGoPrev();
      nextBtn.disabled = !canGoNext();

      var first = new Date(viewYear, viewMonth, 1);
      var startPad = first.getDay();
      var daysInMonth = new Date(viewYear, viewMonth + 1, 0).getDate();
      var i;

      for (i = 0; i < startPad; i++) {
        var empty = document.createElement('span');
        empty.className = 'lb-pickup-scheduler__cal-day is-empty';
        empty.setAttribute('aria-hidden', 'true');
        datesEl.appendChild(empty);
      }

      for (i = 1; i <= daysInMonth; i++) {
        var d = new Date(viewYear, viewMonth, i);
        var iso = toIsoDate(d);
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'lb-pickup-scheduler__cal-day';
        btn.textContent = i;
        btn.dataset.value = iso;
        btn.setAttribute('role', 'gridcell');
        btn.setAttribute('aria-label', DOW[d.getDay()] + ', ' + FULL_MONTHS[viewMonth] + ' ' + i + ', ' + viewYear);

        if (!isDateSelectable(d)) {
          btn.classList.add('is-disabled');
          btn.disabled = true;
        } else {
          btn.addEventListener('click', (function (isoVal, button) {
            return function () {
              selectDate(isoVal, button);
            };
          })(iso, btn));
        }

        if (dateEl.value === iso) {
          btn.classList.add('is-selected');
          selectedDateBtn = btn;
        }

        datesEl.appendChild(btn);
      }
    }

    prevBtn.addEventListener('click', function () {
      if (!canGoPrev()) return;
      if (viewMonth === 0) setViewMonth(viewYear - 1, 11);
      else setViewMonth(viewYear, viewMonth - 1);
    });

    nextBtn.addEventListener('click', function () {
      if (!canGoNext()) return;
      if (viewMonth === 11) setViewMonth(viewYear + 1, 0);
      else setViewMonth(viewYear, viewMonth + 1);
    });

    function restoreSaved() {
      var start = getMinDate();
      if (dateEl.value) {
        var saved = parseIsoDate(dateEl.value);
        if (saved && isDateSelectable(saved)) {
          viewYear = saved.getFullYear();
          viewMonth = saved.getMonth();
        } else {
          dateEl.value = '';
          timeEl.value = '';
          viewYear = start.getFullYear();
          viewMonth = start.getMonth();
        }
      } else {
        viewYear = start.getFullYear();
        viewMonth = start.getMonth();
      }

      renderCalendar();

      if (dateEl.value) {
        selectDate(dateEl.value, selectedDateBtn);
        if (timeEl.value) {
          var timeMatch = timesEl.querySelector('[data-value="' + timeEl.value + '"]');
          if (timeMatch) timeMatch.click();
          else timeEl.value = '';
        }
      }
      updateSelectionSummary();
    }

    restoreSaved();

    var saveTimer;
    function persist() {
      clearTimeout(saveTimer);
      saveTimer = setTimeout(function () {
        if (!dateEl.value || !timeEl.value) return;
        saveAttributes(dateEl.value, timeEl.value)
          .then(function () {
            showStatus('Saved.');
          })
          .catch(function () {
            showError('Could not save pickup details. Please try again.');
          });
      }, 350);
    }

    function openAccordion() {
      var section = root.closest('.lb-cart-section--pickup');
      if (section) {
        try {
          section.scrollIntoView({ behavior: 'smooth', block: 'center' });
        } catch (scrollErr) {
          section.scrollIntoView();
        }
        return;
      }
      var content = root.closest('.accordion-content');
      if (!content) return;
      content.classList.remove('closed');
      var li = content.previousElementSibling;
      if (li && li.classList.contains('tlink')) {
        li.classList.remove('closed');
        var a = li.querySelector('a');
        if (a) {
          a.classList.remove('closed');
          a.setAttribute('aria-expanded', 'true');
        }
      }
    }

    var form = root.closest('form');
    if (form && !form.dataset.lbPickupCheckoutBound) {
      form.dataset.lbPickupCheckoutBound = 'true';
      form.setAttribute('novalidate', 'novalidate');
      form.addEventListener('submit', function (e) {
        var checkoutBtn = form.querySelector('[data-lb-checkout-btn]');
        if (checkoutBtn && e.submitter && e.submitter !== checkoutBtn) {
          return;
        }
        if (!dateEl.value || !timeEl.value) {
          e.preventDefault();
          openAccordion();
          showError('Please choose a pickup date and time before checking out.');
          root.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      });
    }
  }

  function initAll() {
    document.querySelectorAll('[data-lb-pickup-scheduler]').forEach(bindScheduler);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);

  var observer = new MutationObserver(function () {
    initAll();
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
